//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  import // XButton,
// XInput,
    "vux";
  import { mapState } from "vuex";
  import { service, nativeApi } from "@/common/index";
  import { fetch } from "@/page/index";
  import { Dialog } from "vant";

  export default {
    data() {
      return {
        showRespPicker: false,
        respColumns: [],
        showLanPicker: false,
        lanColumns: [],
      };
    },
    components: {},
    computed: {
      ...mapState({
        userInfo: (state) => state.user.userInfo,
        responsibilityId: (state) => state.user.responsibilityId,
        languageCode: (state) => state.user.languageCode,
      }),
      responsibility: {
        get() {
          if (this.userInfo == null) {
            return "";
          }
          const role = this.userInfo.userRespList.find(
            (item) => item.responsibilityId === this.responsibilityId
          );
          return role != null ? role.responsibilityName : "";
        },
        set(val) {},
      },
      respIndex: {
        get() {
          return this.respColumns.findIndex(
            (item) => item.responsibilityId == this.responsibilityId
          );
        },
        set(val) {},
      },
      language: {
        get() {
          if (this.userInfo == null) {
            return "";
          }
          const lan = this.userInfo.languageList.find(
            (item) => item.lookupCode == this.languageCode
          );
          return lan != null ? lan.meaning : "";
        },
        set(val) {},
      },
      lanIndex: {
        get() {
          return this.lanColumns.findIndex(
            (item) => item.code == this.languageCode
          );
        },
        set(val) {},
      },
    },
    created() {},
    activated: function () {},
    methods: {
      initView() {
        //职责列表
        const respList = this.userInfo.userRespList.filter(
          (item) => item.systemCode === "MOBILE"
        );
        if (respList != null) {
          this.respColumns = respList.map((item) => {
            return {
              text: item.responsibilityName,
              responsibilityId: item.responsibilityId,
            };
          });
        }

        //语言列表
        const lanList = this.userInfo.languageList;
        if (lanList) {
          this.lanColumns = lanList.map((item) => {
            return {
              text: item.meaning,
              code: item.lookupCode,
            };
          });
        }
      },
      onChangeResp() {
        this.showRespPicker = true;
      },
      onChangeLan() {
        this.showLanPicker = true;
      },
      onConfirmResp(value) {
        this.showRespPicker = false;
        if (value == null) return;
        const respId = value.responsibilityId;
        this.$store.commit("SET_RESPONSIBILITY", respId);
      },
      onConfirmLan(value) {
        this.showLanPicker = false;
        if (value == null) return;
        const code = value.code;
        this.$store.commit("SET_LANGUAGE", code);
      },
      onAbout() {
        Dialog.alert({
          title: "关于我们",
          message: "版本: SRM6.0 \n版权所有: 广州赛意信息科技股份有限公司",
        });
      },
      onLogout() {
        Dialog.confirm({
          message: "是否确认注销登录",
        }).then(() => {
            //todo: 确认注销
            localStorage.removeItem("userInfo");
            this.$store.commit("LOGOUT");
            this.$router.push("/srmLogin");
          })
          .catch(() => {
            //todo: 取消
          });
      },
      bindWx() {
        localStorage.wxCode = null;
        let ua = window.navigator.userAgent.toLowerCase();
        // 微信环境
        if (ua.match(/MicroMessenger/i) == 'micromessenger') {
          /*let _authorize = "http://zhaocai.cnispcloud.cn/mobilewx/#/mine"
          let _wechatUrl = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx177d11fa4c327f6b&redirect_uri="
          _wechatUrl += encodeURIComponent(_authorize)
          _wechatUrl += "&response_type=code&scope=snsapi_base&state=cnisp&connect_redirect=1#wechat_redirect"
          window.location.href = _wechatUrl*/
          fetch.wechat_authorize().then(res=>{
            if (res.status === "S") {
              window.location.href = res.data;
            } else {

            }
          })
        } else {
          Dialog.alert({
            title: "用户提示",
            message: "请使用微信浏览器绑定"
          });
        }
      },
      //解除微信绑定
      relieveBindWx() {
        Dialog.confirm({
          message: "是否解除微信绑定",
        })
          .then(() => {
            let param = {
              userId : this.userInfo.userId,
              wxOpenId : ""
            }
            fetch.updateWxOpenIdById(param).then(res=>{
              if (res.status === "S") {
                this.$set(this.userInfo, "wxOpenId", "");
                Dialog.alert({
                  title: "用户提示",
                  message: "解绑成功！"
                })
              } else {
                Dialog.alert({
                  title: "用户提示",
                  message: "解绑失败！"
                })
              }
            })
          })
          .catch(() => {
            //todo: 取消
          });
      },
      getUrlParam(paramName) {
        // 获取url中跟在问号后面的部分
        let params = window.location.search
        // 检测参数是否存在
        if (params.indexOf(paramName) > -1) {
          let paramValue = ''
          paramValue = params.substring(params.indexOf(paramName), params.length)
          // 检测后面是否还有参数
          if (paramValue.indexOf('&') > -1) {
            // 去除后面多余的参数, 得到最终 paramName=paramValue 形式的值
            paramValue = paramValue.substring(0, paramValue.indexOf('&'))
            // 去掉参数名, 得到最终纯值字符串
            paramValue = paramValue.replace(paramName + '=', '')
            return paramValue
          }
          return ''
        }
      },
      wxUserInfo(code){
        localStorage.wxCode = code;
        let param = {
          userId : this.userInfo.userId,
          code : code
        }
        fetch.wechat_userInfo(param).then(res=>{
          if (res.status === "S") {
            this.$set(this.userInfo, "wxOpenId", "sss");
            Dialog.alert({
              title: "用户提示",
              message: "绑定成功！"
            })
          } else {
            Dialog.alert({
              title: "用户提示",
              message: "绑定失败！"
            })
          }
        })
      }
    },
    watch: {},
    mounted() {
      this.initView();
      console.log(this.userInfo);
      //截取code
      let code = this.getUrlParam('code');
      if(code && localStorage.wxCode === "null"){
        this.wxUserInfo(code);
      }
    },
  };



// WEBPACK FOOTER //
// ./src/page/srm/home/mine.vue